module.exports = __webpack_public_path__ + "img/ics_f_info_circle.ff9900f3.svg";